import { useWeb3Modal } from '@web3modal/wagmi/react'
import { useEffect } from 'react';
import { recoverMessageAddress } from 'viem';
import { useAccount, useSignMessage } from 'wagmi';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserInfo, fetchVerifySignature } from '../redux/slices/UserSlice';


export const ConnectWallet = () => {
    const { open } = useWeb3Modal();
    const { address, isConnected } = useAccount();
    const { data: signMessageData, signMessage, variables } = useSignMessage()
    const dispatch = useDispatch();
    const isLogin = useSelector(state => state.user.isLogin);

    useEffect(() => {
        ; (async () => {
            if (variables?.message && signMessageData) {
                const recoveredAddress = await recoverMessageAddress({
                    message: variables?.message,
                    signature: signMessageData,
                })

                dispatch(fetchVerifySignature({
                    address: recoveredAddress,
                    signature: signMessageData,
                })).then(() => {
                    dispatch(fetchUserInfo({
                        address
                    }))
                })
            }
        })()
    }, [signMessageData, variables?.message])

    return (
        address && isConnected ? (
            isLogin ? (
                <button onClick={() => open()} type='button' className="btn-main btn-wallet">
                    {`${address.substring(0, 6)}...${address.substring(address.length - 4)}`}
                </button>
            ) : (
                <button onClick={() => signMessage({ message: "BlockStar NFT Login Message" })} type='button' className="btn-main btn-wallet">
                    <i className="icon-wallet mr-md-2" /> <span>Verify Login</span>
                </button >
            )
        ) : (
            <button onClick={() => open()} type='button' className="btn-main btn-wallet">
                <i className="icon-wallet mr-md-2" /><span>Connect Wallet</span>
            </button>
        )
    )
};